import { render } from "./ListWrapper.vue?vue&type=template&id=68a54575&scoped=true&ts=true"
import script from "./ListWrapper.vue?vue&type=script&lang=ts"
export * from "./ListWrapper.vue?vue&type=script&lang=ts"

import "./ListWrapper.vue?vue&type=style&index=0&id=68a54575&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a54575"]])

export default __exports__